import * as Yup from 'yup';

export const PASSWORD_RULES_TEXT =
  'Password must be at least 8 characters and include an uppercase letter, a lowercase letter, and a number.';

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,}).*$/;

export const passwordYup = (options?: { required?: boolean }) => {
  const required = options?.required ?? true;

  let s = Yup.string().trim();

  if (required) {
    s = s.required('Required');
  }

  return s.test('password', PASSWORD_RULES_TEXT, value => {
    if (!required && (!value || !value.trim())) return true;
    return Boolean(value) && PASSWORD_REGEX.test(value);
  });
};
